// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

export const environment = {
    production: false,
    uri: 'http://localhost:9002',
    firebase: {
        apiKey: 'AIzaSyACX4uFJjRZPN3JohXcG9yyJSUPCsA_tI8',
        authDomain: 'kodkat-9ad08.firebaseapp.com',
        databaseURL: 'https://kodkat-9ad08.firebaseio.com',
        projectId: 'kodkat-9ad08',
        storageBucket: 'kodkat-9ad08.appspot.com',
        messagingSenderId: '741462586891'
    }
};
